import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const WCas = {
	name: NAME,
	apiProvider,
	router,
};
